import { Intent } from '@blueprintjs/core';

export default function (error, options) {
  const title = 'Failed to copy to clipboard';
  const description =
    "Copying to clipboard is not supported in your browser or it's not allowed in the website permission settings.";
  const message = 'Copying to clipboard is not allowed in your browser.';

  return {
    title,
    description,
    message,
    toast: true,
    intent: Intent.WARNING,
    icon: 'clipboard',
  };
}
